module.exports = __webpack_public_path__ + "img/ic_work_bg.03431d7f.png";